/* eslint-disable no-debugger */
import axios from 'axios'
import Vue from 'vue'
// import Router from 'vue-router'
import url from '../../public/config'
import qs from 'qs'
import router from '@/router'

export function request (config) {
  axios.defaults.withCredentials = true
  axios.defaults.headers.post['Content-Type'] = 'application/json'
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

  const instance = axios.create({
    baseURL: url.baseUrl,
    timeout: 20000
  })
  instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    config.method = config.method ? config.method : 'get'
    if (config.method === 'get') {
      config.params = config.data
      if (config.data instanceof Object) {
        for (const i in config.data) {
          if (config.data[i] instanceof Array) {
            config.paramsSerializer = function (params) {
              return qs.stringify(params, { arrayFormat: 'repeat' })
            }
          }
        }
      }
    }
    if (config.method === 'put') {
      config.headers.put['Content-Type'] = 'application/json'
    }
    if (config.url === '/auth/login') {
      config.headers.post['Content-Type'] = 'multipart/form-data'
    }
    config.headers.token = token
    return config
  }, err => {
    console.log('请求出错')
    console.log(err)
  })

  instance.interceptors.response.use(res => {
    if (res.status !== 200) {
      Vue.prototype.$message({
        message: res.data.message,
        type: 'error'
      })
      return
    }
    if (res.status === 200) {
      if (!res.data || res.data.code === 401) {
        Vue.prototype.$message({
          message: '登录已过期，请重新登录',
          type: 'error'
        })
        localStorage.clear()
        router.replace('/login')
      }
    }
    const contentDisposition = res.headers['content-disposition'];
    if (contentDisposition && contentDisposition !== 'inline;filename=f.txt') {
      return {
        fileName: decodeURI(contentDisposition.split(';')[1].split("filename*=utf-8''")[1]),
        fileContent: res.data
      }
    }
    return res.data
  }, err => {
    console.log(err)
  })
  return instance(config)
}
